export function MonthToLocal(month: keyof Month.IGetMonths): keyof Month.IMonths {
  return month.length > 2 ? month.slice(4) : month;
}
